module.exports = __webpack_public_path__ + "img/badge-partner.0e4f391d.png";